import type { Person } from 'schema-dts'

/**
 * Builds an "Author" entity for the article structured data.
 */
export function buildAuthor({
  authorDescription,
  authorName,
  url,
}: {
  authorDescription?: string
  authorName: string
  url?: string
}): Person {
  return {
    '@type': 'Person',
    'description': authorDescription,
    'name': authorName,
    'url': url,
  }
}
